// const isMobile = () => {
//   return window.innerWidth <= 1000;
// };

const boot = {
  on: {
    // "": [{ target: "whoAreWe", cond: () => isMobile() }, { target: "details" }],
    "": [{ target: "details" }],
  },
};

const whoAreWe = {
  meta: { path: "/who-are-we" },
  on: {
    NEXT: {
      target: "details",
    },
  },
};

const details = {
  meta: { path: "/apply", step: 1 },
  on: {
    NEXT: {
      target: "verification",
    },
  },
};

const verification = {
  meta: { path: "/apply/verification", step: 2 },
  on: {
    NEXT: "skills",
    BACK: "details",
  },
};

const skills = {
  meta: { path: "/apply/skills", step: 3 },
  on: {
    NEXT: {
      target: "selectInstagramPhotos",
    }
  },
};


const instagram = {
  meta: { path: "/apply/instagram", step: 5 },
  initial: "connectAccount",
  states: {
    connectAccount: {
      on: {
        NO_ACCOUNT: "noAccount",
      },
    },
    noAccount: {
      meta: { path: "/apply/no-account" },
      on: {
        NO_ACCOUNT: "noAccountFinal",
      },
    },
    noAccountFinal: {
      meta: { path: "/apply/no-account-final" },
    },
  },
  on: {
    FAIL: {
      target: "fail",
    },
    CONNECT: {
      target: "selectInstagramPhotos",
    },
    BACK: "skills",
  },
};

const selectInstagramPhotos = {
  meta: { path: "/apply/photos", step: 6 },

  on: {
    LOAD_MORE: "selectInstagramPhotos",
    NEXT: process.env.REACT_APP_MEMBERSHIP_SELECTION_ENABLED === 'true' ? "checkoutMembership" : "complete",
    BACK: "skills",
  },
};

const checkoutMembership = {
  meta: { path: "/apply/membership", step: 7 },

  on: {
    NEXT: "complete",
    BACK: "selectInstagramPhotos",
  },
};

const verifyEmail = {
  meta: { path: "/apply/verify-email/:code", step: 3 },
};

const complete = {
  meta: { path: "/apply/complete" },
};

const fail = {
  meta: { path: "/apply/fail" },
};

const apply = {
  initial: "boot",
  context: { images: [] },
  states: {
    boot,
    details,
    skills,
    instagram,
    selectInstagramPhotos,
    checkoutMembership,
    verification,
    verifyEmail,
    complete,
    fail,
  },
};

export default apply;
